import { render } from "./queryactivitytable.vue?vue&type=template&id=08c654f4"
import script from "./queryactivitytable.vue?vue&type=script&lang=js"
export * from "./queryactivitytable.vue?vue&type=script&lang=js"

import "./queryactivitytable.vue?vue&type=style&index=0&id=08c654f4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__